import React, { useState, useEffect } from 'react';
import './../../App.css';
import './LeaderboardPage.css';

import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';
import ApiService from '../../services/ApiService';

import { Link } from 'react-router-dom';
import ProfilePic from '../../components/profilepic/ProfilePic';
import placeholder from '../../assets/placeholder.png';
import YandexAdComponent from '../../components/YandexAdComponent';

const LeaderboardPage = () => {
    const [loading, setLoading] = useState(true);
    const [leaderboard, setLeaderboard] = useState([]);
    const [selectedTab, setTab] = useState("all");

    var fetched = false;
    useEffect(() => {


        document.title = 'animix - Лидерборд';
        fetchData("all");
    }, []);



    const fetchData = async (tab) => {
        if (!fetched) {
            fetched = true;
            let data;
            if (tab === "all") {
                data = await ApiService.getLeaderboard();

            }
            else {
                data = await ApiService.getLeaderboardWeek();
            }


            if (data.type === "success") {
                setLeaderboard(data.data);
                setLoading(false);
            }

        }

    };

    const handleTabChange = (tabName) => {
        setTab(tabName);
        setLeaderboard(null)
        setLoading(true)
        fetched = false;
        fetchData(tabName);
    };

    const API_DOMAIN = 'https://api.whitewhale.help';

    const hoursOf = (user) => {
        const count = selectedTab === "all" ? user.watchCount : user.watchCountLastWeek;
        return Math.round(count * 20 / 60 * 10) / 10;
    };

    const renderBackground = (user) => (user.subscribed ? (
        <img
            className="leader-card__bg"
            loading="lazy"
            alt=""
            onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = placeholder;
            }}
            src={`${API_DOMAIN}/account/getProfileData/${user.id}_profile_background.png`}
        />
    ) : null);

    const renderCard = (user, index, modifier = '') => (
        <li key={user.id} className={modifier ? `leader-podium__item--${index + 1}` : undefined}>
            <Link to={`/profile/${user.nickname}`} className={`leader-card ${modifier}`}>
                {renderBackground(user)}
                <span className="leader-card__rank">{index + 1}</span>
                <span className="leader-card__avatar"><ProfilePic isBig={false} account={user} /></span>
                <span className="leader-card__name">{user.nickname}</span>
                <span className="leader-card__hours"><strong>{hoursOf(user)}</strong> ч просмотра</span>
            </Link>
        </li>
    );

    return (
        <PageShell sidebar className="leaderboard-page">
            <PageHeader title="Лидерборд" lead="Топ по часам просмотра. Чтобы попасть в список, побейте нижний порог.">
                <div className="ui-chips leader-tabs" role="tablist">
                    <button type="button" role="tab" className="ui-chip" aria-selected={selectedTab === "all"} onClick={() => handleTabChange("all")}>
                        За всё время
                    </button>
                    <button type="button" role="tab" className="ui-chip" aria-selected={selectedTab === "week"} onClick={() => handleTabChange("week")}>
                        За неделю
                    </button>
                </div>
            </PageHeader>

            {loading ? <p className="ui-status">Загружаем…</p> : (
                <>
                    <ol className="leader-podium">
                        {leaderboard.slice(0, 3).map((user, index) => renderCard(user, index, `leader-card--podium leader-card--place-${index + 1}`))}
                    </ol>
                    <ol className="leader-grid" start={4}>
                        {leaderboard.slice(3).map((user, index) => renderCard(user, index + 3))}
                    </ol>
                </>
            )}

            <YandexAdComponent blockId="R-A-8131234-1" />
        </PageShell>
    );
};

export default LeaderboardPage;
